import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import useSocket from "use-socket.io-client";
import {
  useAppEvenListSelector,
  useAppEventGameListSelector,
  useAppRodeoEventLoginRequiredSelector,
} from "src/_common/hooks/selectors/eventSelector";
import {
  CRYPTO_SECRET_KEY,
  getEventStatusText,
  URLS,
  SOCKET_URL,
  SOCKET_CHANNEL,
  INSIDERODEO_EVENT_STORAGE,
  RODEPICK_NEXT_GAME_IDS,
} from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { toast } from "react-toastify";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useAppGuestUserIdSelector, useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import clsx from "clsx";
import Sponsor from "src/components/common/Sponsor";
import UpdateDOBModal from "../modal/updateDOBModal";
import LeagueCodeModal from "../modal/leagueCodeModal";
import moment from "moment";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventGamePage() {
  const eventApi = useEventApi();
  const history = useHistory();
  const eventAction = useAppEventAction();
  const userDetails = useAppUserDetailsSelector();
  const eventGameListSelector = useAppEventGameListSelector();
  const [loginReq, setLoginReq] = useState<any>(0);
  const { eventId, performanceId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  const eventListSelector = useAppEvenListSelector();
  const guestUserId = useAppGuestUserIdSelector();
  const [isEnableDob, setIsEnableDob] = useState<any>(0);
  const [showDOBModal, setShowDOBModal] = useState<boolean>(false);
  const [showLeagueCodeModal, setShowLeagueCodeModal] = useState<boolean>(false);
  const [encryptedGameId, setEncryptedGameId] = useState<any>();
  const [leagueCodeDetails, setLeagueCodeDetails] = useState<any>();
  const [performanceInfo, setPerformanceInfo] = useState<any>();

  const isInsideRodeoTokenExists = localStorage.getItem(INSIDERODEO_EVENT_STORAGE);

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
  });

  useEffect(() => {
    // if (userDetails) {
    socket.connect();

    //Status Change Socket
    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
      eventAction.pushGameStatusChangeSocketDataIntoGameList(changeEventStatus);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.START_EVENT, (changeEventStatus: any) => {
      if (changeEventStatus && changeEventStatus.rodeo_event_id && guestUserId) {
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  const getEventGameList = () => {
    const params: any = {
      rodeo_event_id: e_id,
      game_id: eventListSelector?.game_details.id,
      performance_id: parseInt(cryptr.decrypt(performanceId)),
    };
    if (!userDetails) {
      if (guestUserId) {
        params["guest_user_id"] = guestUserId;
      }
    }
    eventApi.callGetEventGameList(
      params,
      (message: string, resp: any) => {
        // console.log({resp})
        if (resp?.rodeo_event_dtls?.login_required) {
          // eventAction.updateLoginRequired(resp.rodeo_event_dtls.login_required)
          setLoginReq(resp.rodeo_event_dtls.login_required);
        }
        if (resp?.event_dtls?.length) {
          if (resp?.event_dtls[0]?.performance_dtls?.is_enable_dob == 1) {
            setIsEnableDob(1);
          } else {
            setIsEnableDob(0);
          }
        }
        if (resp?.event_dtls[0]?.performance_dtls?.is_enable_league_code == "1") {
          setLeagueCodeDetails({
            league_code_details: resp?.league_code_details,
            is_enable_league_code: resp?.event_dtls[0]?.performance_dtls?.is_enable_league_code,
          });
        }
        setPerformanceInfo(resp?.performance);
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const goToGameDetailsPage = (e: any, event: any) => {
    e.preventDefault();
    if (event?.questions_dtls?.length == 0) {
      toast.error("No questions available for this game.");
      return;
    }
    const gameId = cryptr.encrypt(event?.id);
    if (isEnableDob == 1 && !userDetails?.dob) {
      openDOBModal();
      setEncryptedGameId(gameId);
      return;
    }
    history.push(`/event/${eventId}/${performanceId}/${gameId}`);
  };

  const openLeagueCodeModal = () => {
    setShowLeagueCodeModal(true);
  };

  const closeLeagueCodeModal = (resp: any) => {
    setShowLeagueCodeModal(false);
    getEventGameList();
  };

  const openDOBModal = () => {
    setShowDOBModal(true);
  };

  const closeDOBModal = () => {
    setShowDOBModal(false);
    history.push(`/event/${eventId}/${performanceId}/${encryptedGameId}`);
  };

  useEffect(() => {
    getEventGameList();
  }, []);

  useEffect(() => {
    if (userDetails || loginReq == 0) {
      // history.push(`/event/${eventId}`)
    } else {
      history.push(`${URLS.LOGIN}`);
    }
  }, [loginReq]);

  useEffect(() => {
    if (eventGameListSelector && eventGameListSelector.length) {
      localStorage.setItem(
        RODEPICK_NEXT_GAME_IDS,
        eventGameListSelector.map((x: any) => JSON.stringify(x.id))
      );
    }
  }, [eventGameListSelector]);

  const goToLeaderBoardPage = (e: any) => {
    e.preventDefault();
    history.push(`/result/${eventId}/${performanceId}`);
  };

  return (
    <React.Fragment>
      {showLeagueCodeModal && (
        <LeagueCodeModal
          onClose={closeLeagueCodeModal}
          shouldShow={showLeagueCodeModal}
          rodeoEventId={e_id + ""}
          performanceId={cryptr.decrypt(performanceId)}
        />
      )}
      <div className="main-content-panel">
        <div className="section-title">
          <h1>{performanceInfo?.title}</h1>
          <p>{performanceInfo?.pdate ? moment(performanceInfo?.pdate).format("MMM DD, YYYY") : ""}</p>
        </div>
        <div className="team-list-panel pt-3">
          {eventGameListSelector && eventGameListSelector.length
            ? eventGameListSelector.map((event: any) =>
                event?.user_answers?.length < event?.questions_dtls?.length ||
                (event?.user_answers?.length == 0 && event?.questions_dtls?.length == 0) ? (
                  <div className="team-list-block" key={event.id} onClick={(e) => goToGameDetailsPage(e, event)}>
                    <div className="d-flex gap-2 align-items-center">
                      <div className="team-list-icon">
                        <img
                          src={
                            event?.event_dtls?.avatar?.id != 0
                              ? event?.event_dtls?.avatar?.thumb
                              : "/images/no-image.png"
                          }
                          style={{ width: "100%" }}
                          alt={event?.event_dtls?.title}
                        />
                      </div>
                      <div className="team-list-content flex-grow-1">
                        <h4>{event?.event_title || event?.event_dtls?.title}</h4>
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="progress flex-grow-1"
                            role="progressbar"
                            aria-label="Basic example"
                            aria-valuenow={
                              event?.user_answers?.length && event?.questions_dtls?.length
                                ? (event?.user_answers?.length / event?.questions_dtls?.length) * 100
                                : 0
                            }
                            aria-valuemin={0}
                            aria-valuemax={100}
                          >
                            <div
                              className="progress-bar"
                              style={{
                                width: `${
                                  event?.user_answers?.length && event?.questions_dtls?.length
                                    ? (event?.user_answers?.length / event?.questions_dtls?.length) * 100
                                    : 0
                                }%`,
                              }}
                            />
                          </div>
                          <span className="progress-percnt">
                            {event?.user_answers?.length && event?.questions_dtls?.length
                              ? ((event?.user_answers?.length / event?.questions_dtls?.length) * 100).toFixed(1)
                              : 0}
                            %
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="team-list-block team-list-completed"
                    key={event.id}
                    onClick={(e) => goToGameDetailsPage(e, event)}
                  >
                    <div className="d-flex gap-2 align-items-center">
                      <div className="team-list-icon">
                        <img
                          src={
                            event?.event_dtls?.avatar?.id != 0
                              ? event?.event_dtls?.avatar?.thumb
                              : "/images/no-image.png"
                          }
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className="team-list-content flex-grow-1">
                        <h4>{event?.event_title || event?.event_dtls?.title}</h4>
                        <p>Completed Successfully.</p>
                      </div>
                      <div className="completed-tick">
                        <img src="/images/check.svg" />
                      </div>
                    </div>
                  </div>
                )
              )
            : null}
        </div>
      </div>

      {/* {userDetails && leagueCodeDetails ? (
        <div className="text-center text-white mb-3">
          {leagueCodeDetails?.is_enable_league_code && leagueCodeDetails?.league_code_details?.league_info?.code ? (
            "MY LEAGUE CODE: " + leagueCodeDetails?.league_code_details?.league_info?.code
          ) : (
            <button className="rkmd-btn btn-lg btn-orange ripple-effect w-50" onClick={openLeagueCodeModal}>
              Join League
            </button>
          )}
        </div>
      ) : null} */}

      <Sponsor />

      {showDOBModal && encryptedGameId && <UpdateDOBModal onClose={closeDOBModal} shouldShow={showDOBModal} />}
    </React.Fragment>
  );
}
